import React from 'react';
export function ContentSection() {
  return <section className="bg-gray-50 py-12 md:py-16 px-4" data-id="element-80">
      <div className="max-w-4xl mx-auto" data-id="element-81">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-82">
          📘 ¿Qué incluye exactamente?
        </h2>

        <div className="bg-white rounded-lg shadow-lg p-6 md:p-10 mb-8" data-id="element-83">
          <h3 className="text-2xl md:text-3xl font-black text-purple-900 mb-4" data-id="element-84">
            🔹 EBOOK PRINCIPAL
          </h3>
          <p className="text-xl font-bold text-gray-800 mb-4" data-id="element-85">
            "Hice esto para dejar de pensar en él en 7 días"
          </p>
          <p className="text-lg text-gray-700" data-id="element-86">
            Un paso a paso probado para romper el ciclo emocional y recuperar el
            control.
          </p>
        </div>
      </div>
    </section>;
}